//temporary helper funtions

export const today = + new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

export const parseDateDesktop = (input) => {
	if (input === today) return customData.i18n.agenda_date_today;
	if (input === (today + 86400000)) return customData.i18n.agenda_date_tomorrow;
	return new Date(input).toLocaleDateString(document.documentElement.lang, { weekday: "long", month: "long", day: "numeric" });
};

export const parseDateDesktopShort = (input) => {
  if (input === today) return customData.i18n.agenda_date_today.toLowerCase();
  if (input === today + 86400000) return customData.i18n.agenda_date_tomorrow.toLowerCase();
  return new Date(input).toLocaleDateString('nl', { weekday: 'long', month: 'short', day: 'numeric', year: "numeric" }); // slice to trim last "." after month name
}

export const toSmallDateDisplay = (string) => {
	const stringArr = string.split(' ');
	if (stringArr.length <= 1) {
	//today, tomorrow
	return string;
	}
	const shortWeekday = stringArr[0].split('')[0] + stringArr[0].split('')[1];
	const shortMonth = stringArr[2].split('')[0] + stringArr[2].split('')[1] + stringArr[2].split('')[2];
	return shortWeekday + ' ' + stringArr[1] + ' ' + shortMonth;
};

export const toSmallDateDisplayYear = (string) => {
	const stringArr = string.split(' ');
	if (stringArr.length <= 1) {
	//today, tomorrow
	return '';
	}
	const shortMonth = stringArr[2].split('')[0] + stringArr[2].split('')[1] + stringArr[2].split('')[2];
	return stringArr[1] + ' ' + shortMonth + ' ' + stringArr[3];
};

export const toSmallWeekdayDisplay = (string) => {
	const stringArr = string.split(' ');
	if (stringArr.length <= 1) {
	//today, tomorrow
	return string;
	}
	const shortWeekday = stringArr[0].split('')[0] + stringArr[0].split('')[1];
	return shortWeekday.charAt(0).toUpperCase() + shortWeekday.slice(1)
};

export const toLongDateDisplay = (string) => {
	const stringArr = string.split(' ');
	if (stringArr.length <= 1) {
	//today, tomorrow
	return string;
	}
	const shortWeekday = stringArr[0].split('')[0] + stringArr[0].split('')[1];
	const shortMonth = stringArr[2].split('')[0] + stringArr[2].split('')[1] + stringArr[2].split('')[2];
	return shortWeekday.charAt(0).toUpperCase() + shortWeekday.slice(1) + ' ' + stringArr[1] + ' ' + shortMonth + ' ' + stringArr[3];
};

export const parseDateDesktopMonth = (input) => {
  // if (input === today) return customData.i18n.agenda_date_today;
  // if (input === today + 86400000) return customData.i18n.agenda_date_tomorrow;
  return new Date(input).toLocaleDateString(document.documentElement.lang, { month: 'long', year: "numeric" });
};

export const parseDateDay = (timestamp) => {
	return new Date(timestamp).toLocaleDateString(document.documentElement.lang, { weekday: "long" }).substring(0, 2);
}

export const parseDateNumber = (timestamp) => {
	return new Date(timestamp).toLocaleDateString(document.documentElement.lang, { day: "numeric" });
}

export const dbDateToTimestamp = (programstart) => {
	if (typeof programstart !== 'string') {
		programstart = programstart.toString();
	}
	return + new Date(
		`${programstart.substring(0, 4)}`,
		`${programstart.substring(4, 6) - 1}`,
		`${programstart.substring(6, 8)}`
	);
}

export const dbDateToExactTimestamp = (programstart) => {
	if (typeof programstart !== 'string') {
		programstart = programstart.toString();
	}
	return + new Date(
		`${programstart.substring(0, 4)}`,
		`${programstart.substring(4, 6) - 1}`,
		`${programstart.substring(6, 8)}`,
		`${programstart.substring(8, 10)}`,
      `${programstart.substring(10, 12)}`
	);
}


export const getLatest = (array) => {
	if (array.length < 2) return '';
	return dbDateToTimestamp(array.reduce((a, b) => {
		return new Date(a) > new Date(b) ? a : b;
	}));
}


export const sortByPopularity = (input) => {
	const preSort = sortByRelease(input);
	return preSort.sort((a, b) => b.times.length - a.times.length);
}

export const sortByTime = (input) => {
	input.sort((a, b) => {
		return a.times[0].timestamp - b.times[0].timestamp;
	})
	return input;
}

export const sortByRelease = (input) => {
	let tempWithReleaseDate = input.filter(movie => movie.date_range.release);
	let tempWithoutReleaseDate = input.filter(movie => !movie.date_range.release);

	tempWithReleaseDate.sort((a, b) => {
		return dbDateToTimestamp(a.date_range.release + '0000') - dbDateToTimestamp(b.date_range.release + '0000');
	});

	if (tempWithoutReleaseDate.length > 0) {
		tempWithoutReleaseDate.sort((a, b) => a.title.localeCompare(b.title));
		return tempWithReleaseDate.concat(tempWithoutReleaseDate);
	} else {
		return tempWithReleaseDate;
	}
}

//sorting the movies/events by date and when it's the same date sort by time
export const sortByDate = (input) => {
	let withDates = input.filter(movie => movie.date_range.length > 0);

	withDates.sort((a, b) => {
		if (dbDateToTimestamp(a.date_range[0] + '0000') > dbDateToTimestamp(b.date_range[0] + '0000')) return 1;
		if (dbDateToTimestamp(a.date_range[0] + '0000') < dbDateToTimestamp(b.date_range[0] + '0000')) return -1;
		//when the same date, check for start time
		if (a.times?.length > 0 && b.times?.length > 0) {
			if (a.times[0].program_start.substring(8, 10) > b.times[0].program_start.substring(8, 10)) return 1;
			if (a.times[0].program_start.substring(8, 10) < b.times[0].program_start.substring(8, 10)) return -1;
			if (a.times[0].program_start.substring(10, 12) > b.times[0].program_start.substring(10, 12)) return 1;
			if (a.times[0].program_start.substring(10, 12) < b.times[0].program_start.substring(10, 12)) return -1;
		}
		return 0;
	});

	return withDates;
}

export const sortAlphabetically = (input) => {
	return input.sort((a, b) => a.title.localeCompare(b.title));
}

export const parseEntities = (txt) => {
	return new DOMParser().parseFromString(txt, 'text/html').body.innerText;
}

const bodyWidthEM = () => {
	console.log('window.intterwidth', window.innerWidth);
	console.log('computedStyle body', parseFloat(getComputedStyle(document.querySelector('body'))['font-size']));
	return window.innerWidth / parseFloat(getComputedStyle(document.querySelector('body'))['font-size']);

}

// const checkForTouchScreen = () => {
// 	if ("ontouchstart" in document.documentElement) {
//   		return true;
// 	} else {
//   		return false;
// 	}
// }

export const hideAgenda = (hideOnHomeDesktop) => {
	if (!document.querySelector('.js_react_filter').classList.contains('js_react_filter_home') ) {
		return true;
	} else {
		if (!hideOnHomeDesktop) {
			return true;
		// } else if (bodyWidthEM() < 37.5) {
		} else if (checkForTouchScreen()) {
			return true;
		} else {
			return false;
		}
	}
}

export const vwSet = () => {
	document.documentElement.style.setProperty("--vw", `${document.documentElement.clientWidth / 100}px`);
};

// export const scrollToBegin = (rootElement) => {
// 	const start = rootElement.querySelector(".tab-nav");
// 	if (start) {
// 		document.firstElementChild.style.scrollPaddingBlockStart = getComputedStyle(document.body).getPropertyValue('--header-height');
// 		start.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
// 	}
// }

export const scrollToBegin = () => {
	const start = document.querySelector('.agenda-start');
	const el = document.firstElementChild;
	if (start && el) {
		el.style.scrollPaddingBlockStart = getComputedStyle(document.body).getPropertyValue('--header-height');
		start.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
	}
}

export const scrollToFromTime = (rootElement, filteredMovies) => {
	const nearestShow = filteredMovies.find(movie => {
		return movie.times[0].timestamp > + new Date().getTime(); //future development: use fromTime here
	});
	const nearestShowElement = rootElement.querySelector(`#movie-${nearestShow.post_id}-${nearestShow.times[0].timestamp}`);
	document.firstElementChild.style.scrollPaddingBlockStart = getComputedStyle(document.body).getPropertyValue('--header-height');
	nearestShowElement.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
}

export const getWeekNumber = (timestamp) => {
	const currentDate = new Date(timestamp);
	const onejan = new Date(currentDate.getFullYear(), 0, 1);
	return Math.ceil((((currentDate.getTime() - onejan.getTime()) / 86400000) + onejan.getDay()) / 7);
}

export const getNextMonday = (today) => {
	let newDate = new Date(today);
	newDate.setDate(newDate.getDate() + (((1 + 7 - newDate.getDay()) % 7) || 7));
	return newDate.getTime();
}

export const getTomorrow = (today) => {
	const now = new Date(today);
	return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1).getTime();
}

export const getThisWeekend = (today) => {
	const oneDayMilliseconds = 24 * 60 * 60 * 1000;
	const daysUntilSat = (6- new Date(today).getDay() + 7) % 7;
	return today + (daysUntilSat * oneDayMilliseconds);
}

export const getNextMonth = (today) => {
	const now = new Date(today);
	if (now.getMonth() == 11) {
		return new Date(now.getFullYear() + 1, 0, 1).getTime();
	} else {
		return new Date(now.getFullYear(), now.getMonth() + 1, 1).getTime();
	}
}

export const hasMatchingShowTags = (element, noSpecialTags) => {
	if (element.times && element.times.length > 0) {
		let matchingShowTags = false;
		element.times.forEach((show) => {
			show.tags &&
				show.tags.length > 0 &&
				show.tags.forEach((tag) => {
				if (!noSpecialTags || !noSpecialTags.includes(tag)) {
					matchingShowTags = true;
				}
				});
		});
		return matchingShowTags;
	}
	return false;
};
